import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { PurchaseOrderDetailDto } from "@hisense/shared";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { buildPoHtml, printPo, type PoPrintAudience } from "@/lib/printPo";
import { SaveAsPdfHint } from "@/components/domain/SaveAsPdfHint";
/*
 * Mọi bản in đơn mua từ màn nội bộ đi qua hộp này (danh sách đơn mua, trang sửa đơn mua, đơn mua từ RFQ). Mặc định là bản gửi nhà
 * cung cấp — đó là bản nhân viên lưu PDF rồi gửi đi, nên không mang số PI / RFQ / yêu cầu mua (YC-01, 07/10/2026). Bản nội bộ phải
 * chọn tường minh và chỉ để lưu trong công ty.
 */
export function PoPrintPreview({ po, onClose }: { po: PurchaseOrderDetailDto; onClose: () => void }) {
  const { t } = useTranslation();
  const [audience, setAudience] = useState<PoPrintAudience>("supplier");
  return <Modal title={`${t("poWorkspace.previewPrint")} · ${po.poNumber}`} closeLabel={t("common.close")} onClose={onClose}>
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line p-3">
      <fieldset className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <legend className="sr-only">{t("poWorkspace.printAudience")}</legend>
        {(["supplier", "internal"] as const).map((a) => (
          <label key={a} className="flex min-h-11 items-center gap-2">
            <input type="radio" name="po-print-audience" checked={audience === a} onChange={() => setAudience(a)} />
            <span>{t(`poWorkspace.printAudience_${a}`)}</span>
          </label>
        ))}
      </fieldset>
      <div className="flex flex-wrap items-center gap-3"><SaveAsPdfHint /><Button onClick={() => printPo(po, audience)}>{t("common.print")}</Button></div>
    </div>
    {audience === "internal" && <p role="note" className="border-b border-line bg-warn-tint px-3 py-2 text-xs text-warn">{t("poWorkspace.printAudienceInternalHint")}</p>}
    <iframe title={t("poWorkspace.previewPrint")} sandbox="allow-same-origin" srcDoc={buildPoHtml(po, audience)} className="min-h-[65dvh] w-full flex-1 bg-surface" />
  </Modal>;
}
